/* Judge.me review photos: collapse the thumbnails whose file is gone.

   Several review images 404 on review-images.judgeme.com. Judge.me leaves those
   thumbnails with its `jdgm--loading` skeleton class forever and they paint as
   ~94x1px slivers, so the review grid fills with empty circles and the whole
   section reads as broken.

   Measured on the live PDP: 8 thumbnails, 5 with naturalWidth 0, and exactly
   those same 5 still carrying `jdgm--loading` after 7s. Judge.me REMOVES that
   class once an image decodes, so "still loading well after load" is a reliable
   marker for dead — and unlike a naturalWidth check it cannot mis-fire on an
   image that simply has not started lazy-loading yet (that mistake hid all 8).

   Cosmetic only, fails silent: if this never runs the page looks as it does now. */
(function () {
  if (window.__syJdgmPhotos) return;
  window.__syJdgmPhotos = true;

  var GRACE_MS = 6000; // generous: real lazy loads finish well inside this

  function sweep() {
    var dead = document.querySelectorAll('.jdgm-rev__pic-link.jdgm--loading, .jdgm-rev__pic-img.jdgm--loading');
    for (var i = 0; i < dead.length; i++) {
      var el = dead[i];
      var link = el.closest('.jdgm-rev__pic-link') || el;
      if (link && link.style) link.style.display = 'none';
    }
  }

  function schedule() {
    window.setTimeout(sweep, GRACE_MS);
  }

  function start() {
    schedule();
    // The widget renders async and paginates; re-sweep after new reviews arrive.
    var pending = null;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.querySelector && n.querySelector('.jdgm-rev__pic-img')) {
            window.clearTimeout(pending);
            pending = window.setTimeout(sweep, GRACE_MS);
            return;
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
